import {
  RouteElement,
  RouteGroupElement,
} from "../stores/appStores/ApplicationStore";
import { Role } from "../api/Common/CommonTypes";
import AllAccessUserGuide from "../pages/UserGuideGroup/AllAccessUserGuide";

const userGuideChildrenRoutes: RouteElement[] = [
  {
    key: "/AllAccessUserGuide",
    path: "",
    element: <AllAccessUserGuide />,
    featureID: null,
  },
];

const UserGuideRoutes: RouteGroupElement[] = [
  {
    key: "/UserGuide",
    path: "/UserGuide",
    label: "User Guide",
    directLink: "/UserGuide",
    children: userGuideChildrenRoutes,
    role: [Role.BoardMember, Role.Homeowner],
  },
];

export default UserGuideRoutes;
